import type { FC } from 'react';

export const VitallyLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/vitally-logo.png"
      alt="Vitally"
      className="w-full h-full object-contain"
    />
  </div>
);
